import { useEffect, useSyncExternalStore } from "react";

import { warnActionsAndPortal, warnOrphanActionsContent } from "./lib";
import type { ScreenLayoutStore } from "./screen-layout-store";

/**
 * Dev-only probe rendered by the ScreenLayout root. Subscribes to the
 * store and raises the cross-component conflict warnings. Because every
 * registration in a commit is batched into a single store update, this
 * probe sees fully settled state — the checks cannot false-fire on
 * mount ordering. Returns null, so its re-renders are free.
 */
export const ScreenLayoutWarnings = ({ store }: { store: ScreenLayoutStore }) => {
  const { directActionsCount, portalHostCount, portalEntries } = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot,
  );

  useEffect(() => {
    if (directActionsCount > 0 && portalHostCount > 0) warnActionsAndPortal();
  }, [directActionsCount, portalHostCount]);

  useEffect(() => {
    if (portalEntries.length > 0 && portalHostCount === 0) warnOrphanActionsContent();
  }, [portalEntries.length, portalHostCount]);

  return null;
};

ScreenLayoutWarnings.displayName = "ScreenLayoutWarnings";
